import React from "react";
import {
  Box,
  Typography,
  FormControl,
  Autocomplete,
  TextField,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { AArrowDown } from "lucide-react";

const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const LetterAutocomplete = ({ letter, handleLetterChange }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography
        sx={{
          fontSize: "0.75rem",
          fontWeight: 600,
          color: "#1F2937",
          mb: 0.5,
          ml: 0.5,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <AArrowDown color="#003D78" size="14px" />
        Letter
      </Typography>
      <FormControl fullWidth>
        <Autocomplete
          size="small"
          value={letter || ""}
          onChange={handleLetterChange}
          disableClearable={!letter}
          clearIcon={letter ? <ClearIcon fontSize="small" /> : null}
          options={alphabets}
          getOptionLabel={(option) => option || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Letter"
              sx={{
                width: "95%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    borderColor: "rgba(0, 61, 120, 0.2)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 2px rgba(0, 61, 120, 0.1)",
                    borderColor: "#003D78",
                  },
                },
                "& .MuiInputBase-input": {
                  fontSize: "0.75rem",
                  padding: "8px 12px",
                },
                "& .MuiInputBase-input::placeholder": {
                  fontSize: "0.75rem",
                },
              }}
            />
          )}
          componentsProps={{
            paper: {
              sx: {
                mt: 0.5,
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                borderRadius: "8px",
                "& .MuiAutocomplete-listbox": {
                  fontSize: "0.75rem",
                  maxHeight: "200px",
                  overflowY: "auto",
                  "::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "::-webkit-scrollbar-track": {
                    background: "transparent",
                  },
                  "::-webkit-scrollbar-thumb": {
                    background: "rgba(0, 0, 0, 0.1)",
                    borderRadius: "4px",
                  },
                  "& .MuiAutocomplete-option": {
                    padding: "8px 12px",
                    "&[aria-selected='true']": {
                      backgroundColor: "rgba(0, 61, 120, 0.08)",
                    },
                    "&[data-focus='true']": {
                      backgroundColor: "rgba(0, 61, 120, 0.04)",
                    },
                  },
                },
              },
            },
          }}
        />
      </FormControl>
    </Box>
  );
};

export default LetterAutocomplete;
